export const feeModules = [
  { item: 'Module One' },
  { item: 'Module Two' }
]

export const attendanceFilterData = [
  { key: "Current Week", value: "Current Week" },
  { key: "Current Month", value: "Current Month" },
  { key: "Previous Month", value: "Previous Month" },
  { key: "Current Module", value: "Current Module" },
  { key: "Clear Filters", value: "Filters" },
];

export const studentData = [
  {
    studentId: 1,
    fullName: 'Muzammil Rafiq',
    contactNo: '9090909090',
    email: 'wow@gmail.com',
    banned: true,
    courses: [{
      courseId: 'KKvaYdBJte8hZQBsMTb5',
      feeScreenshots: [
        {
          date: { seconds: 32786273572 },
          status: 'pending',
          feeAmount: 2000
        },
        {
          date: { seconds: 12786273572 },
          status: 'verified',
          feeAmount: 2000
        }
      ]
    }]
  },
  {
    studentId: 2,
    fullName: 'Owais',
    contactNo: '9090937',
    email: 'testingtwo@gmail.com',
    courses: [{
      courseId: 'qKVYwU1uAV0JGuyoPziC',
      feeScreenshots: [
        {
          date: { seconds: 2786273572 },
          status: 'verified',
          feeAmount: 3000
        }
      ]
    }]
  },
  {
    studentId: 1,
    fullName: 'Arham',
    contactNo: '90909035624652',
    email: 'testingthree@gmail.com',
    courses: [{
      courseId: "BY83opdHif5jQzYMIX3P",
      feeScreenshots: [
        {
          date: { seconds: 22786273572 },
          status: 'pending',
          feeAmount: 4000
        },
        {
          date: { seconds: 32786273572 },
          status: 'notVerified',
          feeAmount: 4000
        }
      ]
    }]
  },
  {
    studentId: 1,
    fullName: 'Umair',
    contactNo: '90909035624652',
    email: 'testingthree@gmail.com',
    courses: [{
      courseId: 'MJ24wTnLJXVOjRuZMg6U',
      feeScreenshots: [
        {
          date: { seconds: 32786273572 },
          status: 'pending',
          feeAmount: 5000
        },
        {
          date: { seconds: 2786273572 },
          status: 'refunded',
          refundAmount: 1000,
          feeAmount: 5000
        }
      ]
    }]
  }
]

export const courseTypes = [
  { value: 'advanced', label: 'Advanced' },
  { value: 'beginner', label: 'Beginner' },
]

export const courseGenders = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
  { value: 'both', label: 'Both' },
]